import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SideNavService } from 'src/app/core-flc/sidenav/sidenav.service';
import { RouterLinkEnum } from 'src/app/enums/router-link-enum';
import { LoadChainageControllerService } from 'src/app/server-api/services';
import { ListComponent } from 'src/app/utils-flc/list/list.component';

@Component({
  selector: 'app-load-chainage-list',
  templateUrl: './load-chainage-list.component.html',
  styleUrls: ['./load-chainage-list.component.css']
})
export class LoadChainageListComponent extends ListComponent {

  constructor(public override translate: TranslateService, public override sidenavService: SideNavService, private loadService: LoadChainageControllerService) {
      super(translate, sidenavService);

      translate
      .get(['load-chainage.button_create', 'icon_refresh', 'action_show'
    ])
      .subscribe((translations: string) => {
        this.topMenuIcons = [
          {icon: "add", title: translations['load-chainage.button_create'], routerLink: RouterLinkEnum.LOAD_CHAINAGES.toString() + "new", clickMethod: "dummy", checkDisable:true},
          {icon: "refresh", title: translations['icon_refresh'], routerLink: null, clickMethod: "refresh"}
        ];
        this.actions = [
          {icon: "playlist_add", title: translations['action_show'], routerLink: RouterLinkEnum.LOAD_CHAINAGES.toString(), clickMethod: "dummy"}
        ];
      });
      this.constructorName = 'LoadChainageList';
    }

  override ngOnInit(): void {

    this.placeholderSearchText = 'load-chainages.search';
    this.exportPrefix = 'load_chainage_';
    this.primarySort.active = 'chainage';
    this.defaultSort.active = 'chainage';
    this.profilesAllowEdit = 'ADMIN,ENGINEER';

    super.ngOnInit();

    this.displayedColumns = ['actions', 'chainage', 'loadPoint', 'load', 'gravelStartPosition', 'kSubSoil', 'gravelSpacing', 'gravelDiffOptimalThick','baseSurveyDiff', 'bermHeightTarget', 'name'];
  }

  override getItems() {
    super.getItems();
    this.loadService.getLoadChainages({ page: this.paginator.pageIndex, size: this.paginator.pageSize, sort: [this.dataSource.sort.active + ',' + this.dataSource.sort.direction], filter: this.filter.nativeElement.value }).subscribe(
      value  => {
        this.dataSource.data = value['content'];
        this.listIds = this.dataSource.data.map(d => d.id);
        this.totalElements = value['totalElements'];
        this.sidenavService.setLoading(false);
      }
    ,
      error => {
        console.error(JSON.stringify(error));
        this.sidenavService.setLoading(false);
      }
        ,
      () => {
        this.sidenavService.setLoading(false);
      }
    );
  }
}


